























































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { listOfYears, monthNames } from "./utils";

@Component
export default class DatePagination extends Vue {
  @Prop({
    default: () => {
      return monthNames;
    }
  })
  public monthNames!: string[];

  @Prop({ default: false })
  public disabled!: boolean;

  @Prop({ required: true })
  public value!: { year: number; month: number };

  public focusedDateData: any = {
    year: this.value.year,
    month: this.value.month
  };

  public get listOfYears() {
    // get 20 year before and after currently selected year
    return listOfYears({
      yearsRange: [
        this.focusedDateData.year - 20,
        this.focusedDateData.year + 20
      ]
    });
  }

  public next() {
    if (this.focusedDateData.month < 11) {
      this.focusedDateData.month += 1;
    } else {
      this.focusedDateData.month = 0;
      this.focusedDateData.year += 1;
    }
    this.$emit("input", this.focusedDateData);
  }

  public prev() {
    if (this.focusedDateData.month > 0) {
      this.focusedDateData.month -= 1;
    } else {
      this.focusedDateData.month = 11;
      this.focusedDateData.year -= 1;
    }
    this.$emit("input", this.focusedDateData);
  }
}
